import { Component, Input, OnInit } from '@angular/core';
import { StudijnyProgram } from '../model/studijny-program';

@Component({
    selector: 'app-studijny-program',
    templateUrl: './studijny-program.component.html',
    styleUrls: ['./studijny-program.component.css'],
    standalone: false
})
export class StudijnyProgramComponent {

  @Input() studProgram: StudijnyProgram;

  checkboxClick($event) {
    $event.stopPropagation();
  }

}
